import { config } from "./config";
import { DetectorType } from "./enum";

let isLastStateOpenedBool = false;

const OpenState: {
  [prop in DetectorType]?: boolean;
} = {};

export function markDevToolOpenState(type: DetectorType) {
  OpenState[type] = true;
}

export function clearDevToolOpenState(type: DetectorType) {
  OpenState[type] = false;
}

export function isDevToolOpened() {
  for (const key in OpenState) {
    if (OpenState[key as unknown as DetectorType]) {
      isLastStateOpenedBool = true;
      return true;
    }
  }
  isLastStateOpenedBool = false;
  return false;
}
